import moment from "@/utils/moment";
import "moment/locale/pt-br";
moment.locale("pt-BR");

const convertDateObject = (date, format = "DD/MM/YYYY") => {
  return moment(date).format(format);
};

const weekday = date => {
  return moment(date).format("dddd");
};

const matchDate = (a, b) => {
  return moment(a).isSame(moment(b), "day");
};

export default {
  methods: {
    convertDateObject,
    matchDate
  },
  filters: {
    weekday,
    formatDate(date, type = "DD/MM/Y HH:mm:ss") {
      return moment(date).format(type);
    },

    greaterDate(dates) {
      var greater = false;

      dates.map(date => {
        greater = greater ? (date > greater ? date : greater) : date;
      });

      return greater;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/dateMixin.js